"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeguardFunctionLogWrapper = exports.typeguardFunctionWrapper = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const Log_1 = require("../types/Log");
const typeguardFunctionWrapper = (schema) => (obj, onErrors) => {
    const { valid, errors } = jsonschema_1.default.validate(obj, schema, {
        nestedErrors: true,
    });
    if (errors.length > 0 && onErrors) {
        onErrors(errors);
    }
    return valid;
};
exports.typeguardFunctionWrapper = typeguardFunctionWrapper;
const typeguardFunctionLogWrapper = (params) => (obj, logOptions) => {
    return (0, exports.typeguardFunctionWrapper)(params.schema)(obj, (errors) => {
        if (logOptions === null || logOptions === void 0 ? void 0 : logOptions.logger) {
            const errorMessages = errors.map(({ message }) => message).join(', ');
            const errObj = {
                message: `"${params.typeguardName}" typeguard incurred ${errors.length} errors: ${errorMessages}`,
                metadata: {
                    logMeta: {
                        validationErrorStacks: errors.map((err) => err.stack),
                    },
                },
            };
            logOptions.logger(errObj, logOptions.logLevel || Log_1.LogLevel.Error);
        }
    });
};
exports.typeguardFunctionLogWrapper = typeguardFunctionLogWrapper;
//# sourceMappingURL=typeguardUtils.js.map